export const REL_TYPES = Object.freeze({
  NO_FOLLOW: 'no_follow',
  SPONSORED: 'sponsored',
  UGC: 'user_generated_content'
});